import {LiveDashboard} from "@common/ui-components/live/live-dashboard/live-dashboard";
import collection from "./gauge-chart-collection.json";
import data from "./gauge-chart-data.json";

export const GaugeChartThemeAuto = (props) => {
    return LiveDashboard({
        collection,
        defaultData: data,
        disabledTileActions: true,
        ...props,
    });
};
